import React, { Component } from 'react'
import 'css/user-info.css'
import 'css/phones.css'
import { Icon, Modal, Upload, Avatar } from "antd";
import icon_userInfo_upload from "../../style/imgs/icon_userInfo_upload.png"
import { API, _baseURL } from "../../configs/api.config";
import { Toast, Picker, List } from 'antd-mobile'
import { connect } from 'react-redux'
import { fetchPost, fetchGet } from "../../utils/fetchRequest";
import UploadEnclosure from "../../components/UploadEnclosure";
import ImagesViewer from '../../components/imagesVIewer/index'
import { isObjEmpty } from "../../utils/common";
import { switchUser } from "../../redux/actions/userInfo";

class UserInfo extends Component {
    //老师是1家长是2
    static defaultProps = {
        type: 1,
        userName: '',
        school: '',
        phone: '',
        id: '',
    }

    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            fileList: [],
            sex: 0,
            voteType: '',
            typeVote: [{
                label: '男',
                value: 1
            }, {
                label: '女',
                value: 0
            }]
        }
    }

    componentWillMount() {
        const { userInfo } = this.props
        if (this.props.match.params.type) {
            this.type = this.props.match.params.type
        }
        document.title = '个人信息'
        this.state.sex = (this.type == 1 ? userInfo.teacher.teacherSex : userInfo.parent.student.stuSex)
    }


    componentDidMount() {
        // this.updateUserInfo("");
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        return <div className={'user-column'}>
            {this.showUserInfo()}
            <span className={'lineMax'} />
            {this.showLocation()}
            <span className={'lineMax'} />
            {this.showUserContact()}
        </div>
    }

    //显示顶部个人信息
    showUserInfo() {
        const { userInfo } = this.props
        let userName = '', userAvatar = ''

        if (this.type == 1) {
            userName = userInfo.teacher.teacherName
            userAvatar = userInfo.userAvatar
        } else if (this.type == 2) {
            userName = userInfo.parent.student.stuName
            // userAvatar = userInfo.parent.student.stuPhoto
            userAvatar = userInfo.userAvatar
        }
        return <div className='user-row user-row_green'>
            {isObjEmpty(userAvatar) ?
                <Avatar size={50} icon='user' /> :
                <img className='user-info-avatar' onClick={this.onAvatarClick}
                    src={userAvatar} />}
            <div className="flex_row_center user-info-msg">
                <span>{userName}</span>
            </div>
        </div>
    }

    //显示个人位置信息
    showLocation() {
        const { userInfo } = this.props
        const { sex } = this.state;

        let schoolName = ''
        if (this.type === 1) {
            schoolName = userInfo.teacher.teacherWithSchool
        } else {
            schoolName = userInfo.parent.schoolName
        }
        return <div className={'user-column'}>
            <div className='user-info-item-top'>
                <text className='user-info-item-name'>所在学校</text>
                <text className='user-info-item-phone'>{schoolName}</text>
            </div>
            <div className='gray-line' style={{ height: '1px' }}></div>
            {this.type == 1 ?
            <div className='user-info-item-top'>
                <text className='user-info-item-name'>学生学号</text>
                    <text className='user-info-item-phone'>{userInfo.teacher.teacherNumber}</text>
            </div>:
            <div className='user-info-item-top'>
                <text className='user-info-item-name'>教师编号</text>
                <text className='user-info-item-phone'>{userInfo.parent.student.stuNumber}</text>
            </div>}
            <div className='gray-line' style={{ height: '1px' }}></div>
            <Picker
                data={this.state.typeVote} title='性别' extra={sex === 1 ? '男' : '女'}
                value={this.state.voteType}
                onChange={this.onChangeSex} cols={1}>
                <List.Item arrow="horizontal" style={{ width: "100%", fontSize: "14px", padding: "0px 0px 0px 20px", alignItems: "center", height: "max-content", color: "#666666", textAlign: "left" }}>{this.type == 1 ? '教师性别' : '学生性别'}</List.Item>
            </Picker>
            <div className='gray-line' style={{ height: '1px' }}></div>
            <div className='user-info-item-top'>
                <text className='user-info-item-name'>身份信息</text>
                <text className='user-info-item-phone'>{this.type == 1 ? '优秀教师' : '优秀学生'}</text>
            </div>
            <div className='gray-line' style={{ height: '1px' }}></div>
            {this.type == 1 ? '' : <div>
                <div className='user-info-item-top'>
                    <text className='user-info-item-name'>家长姓名</text>
                    <text className='user-info-item-phone'>{userInfo.parent.parentsName}</text>
                </div>
            </div>}
        </div>
    }

    //显示个人联系方式
    showUserContact() {
        const { previewVisible, fileList } = this.state;
        const { userInfo } = this.props

        let pictureUrls = []
        if (this.type == 2 && !isObjEmpty(userInfo.parent, userInfo.parent.student, userInfo.parent.student.stuPhoto)) {
            pictureUrls.push(userInfo.parent.student.stuPhoto)
        } else if (!isObjEmpty(userInfo.teacher, userInfo.teacher.teacherPhoto)) {
            pictureUrls.push(userInfo.teacher.teacherPhoto)
        }

        let userPhone = ''
        if (this.type == 1) {
            userPhone = userInfo.teacher.userPhone
        } else if (this.type == 2) {
            userPhone = userInfo.parent.userPhone
        }
        return <div className={'user-column'}>
            <div className='user-info-item-top'>
                <div>
                    <text className='user-info-item-name'>手机号</text>
                    <div className='user-info-item-phone' style={{ marginTop: '8px' }}>{userPhone}</div>
                </div>
                <div className="item_flex_1 flex_row_right">
                    <div className='gray-line'
                        style={{ height: '34px', background: '#CCCCCC', width: '1px' }}></div>
                    <text className="margin_left_20" style={{ color: "#3680ED" }}
                        onClick={this.onChangePhone}>更换
                    </text>
                </div>
            </div>
            <div className='gray-line' style={{ height: '1px' }}></div>
            {this.type == 2 ?
                <div onClick={this.onPhoneItem} className="text-center" style={{ color: "#0CE11D", fontSize: 12, margin: 10 }}>+ <span style={{ color: "#666666", borderBottom: "1px #000 solid" }}>查看添加号码</span></div>
                : ''}
            <div className='gray-line' style={{ height: '1px' }}></div>

            {<div>
                <div className='user-info-item-top'>
                    {this.type == 2 ?
                        <text className='user-info-item-name'>学生人脸照</text> :
                        <text className='user-info-item-name'>人脸照</text>}
                    <div className='gray-line'
                        style={{ height: '34px', background: '#CCCCCC', width: '1px' }}></div>
                    {this.type == 0 ?
                        <span className="fileinput-button margin_left_20" style={{ color: "#3680ED" }}>
                            上传
                            {/*<input type="file" accept="image/*" capture="camera" onChange={this.uploadChange}/>*/}
                            <UploadEnclosure
                                action={API.UPLOAD_FILE}
                                fileList={fileList}
                                count={1}
                                multiple={false}
                                handlePreview={this.enclosurePreview.bind(this)}
                                beforeUpload={this.beforeUpload.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                            />
                        </span> : ''}
                </div>
                <div className='flex' style={{ marginTop: '8px' }}>
                    <img style={{ marginLeft: "16px" }}
                        src={pictureUrls.length === 0 ? icon_userInfo_upload :
                            pictureUrls[0]}
                        width={86}
                        height={100}
                        onClick={this.handlePreview} />

                    <div style={{ marginLeft: '14px' }}>
                        <div className="user-info-photo-text">• 请按照证件照的样式拍摄正面</div>
                        <div className="user-info-photo-text">• 请保证光线充足，没有遮挡物</div>
                        <div className="user-info-photo-text">• 请取下您的眼镜帽子保持面部曝光率</div>
                    </div>
                </div>

                {previewVisible ?
                    <ImagesViewer onClose={this.handleCancel} urls={pictureUrls}
                        index={0}
                        needPoint={false} /> : ""}
            </div>}

        </div>
    }

    onChangePhone = () => {
        this.props.history.push('/changephonenumber')
    }

    onChangeSex = (color) => {
        const { userInfo } = this.props
        console.log('sex1',color)
        if (color == 0) {
            color = 2;
        }
        if (color == 1) {
            color = 1;
        }

        this.isRequesting = true
        fetchPost(API.updateSex, {
            stuId: this.props.userInfo.parent.student.stuId,
            stuSex: color,
        }, {}).then((response) => {
            console.log('response', response)
            this.isRequesting = false
            if (response.success) {
                this.isRequesting = true
                Toast.show("更换成功")

                this.setState({
                    changeSuccess: true,
                    sex: color,
                },
              /*function () {
                  this.props.history.goBack()
              }*/)
            }
        }).catch((error) => {
            this.isRequesting = false
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    handlePreview = () => {
        this.setState({
            previewVisible: true,
        });
    }

    handleCancel = () => this.setState({ previewVisible: false })

    beforeUpload = (file, fileList) => {
        Toast.loading('人脸照上传中...', 0)
    }

    handleChange = fileList => {
        if (fileList) {
            this.setState({ fileList })

            if (fileList[0].status === 'error') {
                Toast.fail('人脸照上传失败，请重试！')
                this.setState({
                    fileList: []
                })
            } else if (fileList[0].status === 'done') {
                if (this.type == 2) {
                    this.updateUserInfo(fileList[0].response.data)
                } else {
                    this.updateTeacherInfo(fileList[0].response.data)
                }
            } else if (fileList[0].status === 'uploading') {

            } else {
                Toast.hide()
            }
        }
    }

    enclosurePreview = () => {

    }

    updateUserInfo = (userPhoto) => {
        fetchPost(API.UPDATE_STU_PHOTO, {
            stuId: this.props.userInfo.parent.student.stuId,
            stuPhoto: userPhoto.accessPath
        }).then((response) => {
            Toast.success('人脸照上传成功！')
            this.setState({
                fileList: []
            });

            switchUser({
                parent: {
                    ...this.props.userInfo.parent,
                    student: {
                        ...this.props.userInfo.parent.student,
                        stuPhoto: userPhoto.accessPath
                    }
                }
            })()
        }).catch((error) => {
            Toast.hide();
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('人脸照上传异常', 2)
            }
        })
    }

    updateTeacherInfo = (userPhoto) => {
        fetchPost(API.UPDATE_TRACHER_PHOTO, {
            teacherId: this.props.userInfo.teacher.teacherId,
            teacherPhoto: userPhoto.accessPath
        }).then((response) => {
            Toast.success('人脸照上传成功！')
            this.setState({
                fileList: []
            });

            switchUser({
                teacher: {
                    ...this.props.userInfo.teacher,
                    teacherPhoto: userPhoto.accessPath
                }
            })()
        }).catch((error) => {
            Toast.hide();
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('人脸照上传异常', 2)
            }
        })
    }

    //头像点击事件
    onAvatarClick = (event) => {
        //TODO 点击头像
    }


    uploadChange = (e) => {
        this.uploadFile(e.target.files[0])
    }

    uploadFile = (file) => {
        const formData = new FormData();
        formData.append('file', file);
        Toast.loading("")
        fetch(API.UPLOAD_FILE, {
            method: "POST",
            body: formData,
            mode: 'cors',
        }).then(function (response) {
            let result = response.json();
            if (response.status === 200) {
                console.log("text:", result);
                return result;
            } else {
                Toast.success("上传失败！")
            }
        }).then(result => {
            if (result.success) {
                Toast.success("上传成功！");
                let imageUrl = result.data;
                this.state.imageUrl = imageUrl;
                this.setState({
                    imageUrl: imageUrl
                });
                if (this.type == 2) {
                    this.updateUserInfo(imageUrl)
                } else {
                    this.updateTeacherInfo(imageUrl)
                }
            }
        }).catch(function (ex) {
            Toast.fail("上传失败！")
        })
    }

    onPhoneItem = () => {
        this.props.history.push('/PhoneInfo')
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo },
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo)